import { ff } from '@atlassian/jira-feature-flagging';
import type { Action } from '@atlassian/react-sweet-state';
import type { StoreBaseContainerProps } from '../../../../common/types/index.tsx';
import { createDataResponse, createErrorResponse } from '../../../../common/utils/store/index.tsx';
import { multiplePromiseSettler } from '../../utils/index.tsx';
import * as endpoints from '../endpoints/index.tsx';
import type { UsersAndRolesState } from '../types.tsx';

const getUsersWithoutAdminRole =
	(): Action<UsersAndRolesState, StoreBaseContainerProps> =>
	({ setState }, { cloudId }) => {
		setState({
			usersWithoutAdminRole: { data: null, error: null, loading: true },
		});

		return endpoints
			.getUsersWithoutAdminRole(cloudId)
			.then((res) => {
				setState({ usersWithoutAdminRole: createDataResponse(res) });
			})
			.catch((err) => {
				// TODO we might display toast
				setState({ usersWithoutAdminRole: createErrorResponse(err) });
				throw err;
			});
	};

const getUsersWithoutCustomRole =
	(): Action<UsersAndRolesState, StoreBaseContainerProps> =>
	({ setState }, { cloudId }) => {
		setState({
			usersWithoutCustomRole: { data: null, error: null, loading: true },
		});

		return endpoints
			.getUsersWithoutCustomRole(cloudId)
			.then((res) => {
				setState({
					usersWithoutCustomRole: createDataResponse(res),
				});
			})
			.catch((err) => {
				// TODO we might display toast
				setState({ usersWithoutCustomRole: createErrorResponse(err) });
				throw err;
			});
	};

const getStakeholders =
	(): Action<UsersAndRolesState, StoreBaseContainerProps> =>
	({ setState }, { cloudId }) => {
		setState({
			stakeholders: { data: null, error: null, loading: true },
		});

		return endpoints
			.getStakeholders(cloudId)
			.then((res) => {
				setState({
					stakeholders: createDataResponse(res),
				});
			})
			.catch((err) => {
				// TODO we might display toast
				setState({ stakeholders: createErrorResponse(err) });
				throw err;
			});
	};

const initialize =
	(
		hasJsmAboveStandard: boolean,
	): Action<UsersAndRolesState, void, Promise<PromiseSettledResult<void>[]>> =>
	({ dispatch }) => {
		if (ff('platform.show-optimal-tooling_brgom') && hasJsmAboveStandard) {
			return Promise.allSettled([
				dispatch(getUsersWithoutCustomRole()),
				dispatch(getUsersWithoutAdminRole()),
				dispatch(getStakeholders()),
			]).then(multiplePromiseSettler);
		}

		return Promise.allSettled([
			dispatch(getUsersWithoutCustomRole()),
			dispatch(getUsersWithoutAdminRole()),
		]).then(multiplePromiseSettler);
	};

export const actions = {
	getUsersWithoutAdminRole,
	getUsersWithoutCustomRole,
	getStakeholders,
	initialize,
};
